export default {
  colors: {
    almostWhite: "f9f9f9",
    altVeryLightGray: "#eee",
    veryLightGray: "#f8f8f8",
    lightGray: "#ecebeb",
    gray: "#ded9d6",
    darkerGray: "#ccc",
    gray55: "#8c8c8c",
    anotherGray: "#777",
    stoneGray: "#aeada8",
    almostBlack: "#333",
    altAlmostBlack: "#1e1e1e",
    basicallyBlack: "#0e0e0e",
    whiteSmoke: "#f5f5f5",
    silver: "#9999A0",
    silverGray: "#ddd",
    grayOrange: "#bcb1ab",
    darkGrayOrange: "#9a918c",
    forestGreen: "#457564",
    green: "#007254",
    darkGreen: "#255443",
    brown: "#77706b",
    darkBrown: "#3c3639",
    altBrown: "#6d615b",
    primaryBlue: "#428bca",
    darkerPrimaryBlue: "#3276b1",
    mintGreen: "#c3d8cc",
    lightMintGreen: "#e7f3ea",
    mutedOlive: "#71675b",
    reddishOrange: "#d9534f",
    darkRed: "#s43f3a",
    lightYellow: "#FCF8E3",
    darkYellow: "#FBEED5",
    boldGray: "#777777",
  },
  size: {
    large_desktop: "@media(min-width: 1000px)",
    desktop: "@media (max-width: 1000px)",
    mobile: "@media (max-width: 900px)",
  },
}



// WEBPACK FOOTER //
// ./src/utils/style.js